// /**
//  * First we will load all of this project's JavaScript dependencies which
//  * includes Vue and other libraries. It is a great starting point when
//  * building robust, powerful web applications using Vue and Laravel.
//  */

require("./bootstrap");
require("./slick");
require("./cookies/cookieconsent");
require("./cookies/cookieconsent-init");
require("./contactform");
import { initCbreSlider } from "./cbreslider";
import { initCbreSelect } from "./cbreselect";
import { initCbreSelectMultiple } from "./cbreselectmultiple";

$(function() {
    // EW CODE START
    $(".menu_toggle").on("click", function() {
        $("html").toggleClass("menu-opened");
    });

    //Add class to header when page is not at scroll top = 0
    if ($(".no-transparent").length <= 0) {
        checkScroll();
        $(window).on("scroll", function() {
            checkScroll();
        });
    }

    function checkScroll() {
        if ($(window).scrollTop() > 0) {
            $("header").removeClass("not-scrolled");
        } else {
            $("header").addClass("not-scrolled");
        }
    }

    $(".solicitarInformacion").on("click", function() {
        var floor = $(this)
            .parent()
            .parent()
            .parent()
            .parent()
            .find("div:first-child")
            .find(".typeFloor")
            .text()
            .trim();
        $("#input-floor").val(floor);
    });

    $(window).on("load", function() {
        var getUrl = window.location.href;
        $(".nav-link").each(function() {
            if ($(this).attr("href") == getUrl) {
                $(this).addClass("active");
            }
        });
        if ($(".cbreSelect-wrap").length > 0) {
            $(".cbreSelect-wrap")
                .find("ul.cbreSelect-options")
                .find("li")
                .addClass(["d-flex", "alg-center"]);
        }

        // Scroll to accordion if url has anchor in property detail page
        let url = window.location.href;
        if (url.indexOf("#viv-") > 0) {
            var idAcordeon = url.split("#");
            idAcordeon = "#" + idAcordeon[1];
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $(idAcordeon).offset().top - 100
                },
                1000
            );
            $(idAcordeon)
                .find(".std-listener")
                .trigger("click");
        }
    });

    initCbreSlider();

    $("#sliderValores").cbreSlider({
        base: {
            numDisplaySlides: 4
        },
        spacing: 20,
        navigation: {
            active: true,
            mobileBreakPoint: 1024,
            positionTop: "0%",
            onTitle: true
        }
    });

    $("#sliderObraNueva").cbreSlider({
        base: {
            numDisplaySlides: 3
        },
        spacing: 20,
        navigation: {
            active: true,
            mobileBreakPoint: 1024,
            positionTop: "0%",
            onTitle: true
        }
    });
    $("#sliderViviendasSingulares").cbreSlider({
        base: {
            numDisplaySlides: 3
        },
        spacing: 20,
        navigation: {
            active: true,
            mobileBreakPoint: 1024,
            positionTop: "0%",
            onTitle: true
        }
    });

    $("#sliderTrust").cbreSlider({
        base: {
            numDisplaySlides: 1
        },
        navigation: {
            hideNavButtonMobile: false
        },
        desktop: false,
        mobileOnly: true
    });

    $("#slideBlogHome").cbreSlider({
        base: {
            numDisplaySlides: 1
        },
        navigation: {
            hideNavButtonMobile: false
        },
        desktop: false,
        mobileOnly: true
    });

    // animate anchor link clicks
    $('a[href^="#"]').on("click", function(e) {
        if ($(this).attr("href") != "#") {
            e.preventDefault();
            $("html, body").animate(
                {
                    scrollTop: $($(this).attr("href")).offset().top - 80
                },
                500,
                "linear"
            );
        }
    });

    // init all the cbreSelect elements
    initCbreSelect();
    initCbreSelectMultiple();

    // init all the accordions
    initAccordions();

    $(".houseMap").on("click", function(e) {
        e.preventDefault();
        initMapLightBox(e);
        $(".mapLightBox").addClass("visible");
    });

    // init lightbox gallery in property detail page
    if ($(".producto-slider-container").length > 0) {
        initLightBox();
        setSliderListListeners();
        setDetailPanorama();
    }

    // init results slider in property listing page
    initResultsSlider();

    // init iframes
    initIframes();

    // init promotions filters
    if ($("#filtros").length > 0) {
        initPromotionsFilters();
    }

    $(".cbreModal_open").on("click", function() {
        $(".cbreModal").fadeIn("fast");
    });
    $(".cbreModal_close, .cbreModal_bg").on("click", function() {
        $(".cbreModal").fadeOut("fast");
    });

    if ($(".tiny-gallery").length > 0) {
        initMapGallery();
    }

    $(function() {
        if ($(".errors").length > 0) {
            const hasErrors = $(".errors ul").children("li").length > 0;

            if (hasErrors) {
                const offset = 280;

                $("html, body").animate(
                    {
                        scrollTop: $("#formContact").offset().top - offset
                    },
                    800
                );
            }
        }
    });

    const input = document.querySelector("#input-phone");
    const iti = window.intlTelInput(input, {
        utilsScript:
            "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.8/build/js/utils.js",
        initialCountry: "es",
        separateDialCode: true,
        autoPlaceholder: "aggressive", // Muestra el formato esperado
        nationalMode: true, // Permite escribir el número en formato nacional
        formatOnDisplay: true // Activa el formateo en tiempo real
    });

    // Restringir caracteres no numéricos
    input.addEventListener("input", function() {
        this.value = this.value.replace(/[^\d\s\+\-()]/g, "");
    });

    // Validar número al salir del input
    input.addEventListener("blur", function() {
        if (!iti.isValidNumber()) {
            if ($(".error-phone").length == 0) {
                const errorPhone = "El número de teléfono no es válido.";
                $("#formContact").before(
                    "<p class='errors error-phone'>" + errorPhone + "</p>"
                );
                input.classList.add("errors");
            }
        } else {
            if ($(".error-phone").length > 0) {
                $(".error-phone").remove();
            }
            input.classList.remove("errors");
        }
    });

    $("#input-phone").on("input", function() {
        var dialCode = $(".iti__selected-dial-code")
            .text()
            .trim();
        $("#country-code").val(dialCode);
    });

    // if ($("#input-phone").val().trim().length > 0) {
    //     var dialCode = $(".iti__selected-dial-code").text().trim();
    //     $("#country-code").val(dialCode);
    //     console.log(dialCode);
    // }
    // EW CODE END
});

var nearbyMarkers = [];
var infowindows = [];
var map;
var searchDebounce;
var commonFilters = [];
var locationFilters = [];
var removeTitles = false;

window.initMap = initMap;

async function initMap() {
    let $mapInfo = $("#map");

    // Localización del inmueble.
    let position = {
        lat: parseFloat($mapInfo.data("lat")),
        lng: parseFloat($mapInfo.data("lng"))
    };

    // Estilo para ocultar los POIs.
    let styles = [
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
        }
    ];

    const { Map } = await google.maps.importLibrary("maps");

    // Instanciación del mapa.
    map = new Map(document.getElementById("map"), {
        center: position,
        zoom: 16,
        styles: styles,
        options: {
            streetViewControl: true,
            overviewMapControl: false,
            panControl: false,
            mapTypeControl: false,
            scaleControl: false,
            styles: styles
        }
    });

    // Pin del inmueble.
    new google.maps.Marker({
        map: map,
        position: position,
        icon: "/images/gmaps-marker.png",
        zIndex: 2
    });

    // Nearby Places.
    setNearbyPlaces();
}

async function setNearbyPlaces() {
    if (null != nearbyPlaces && 0 < nearbyPlaces.length) {
        for (var e = 0; e < nearbyPlaces.length; e++) {
            for (
                var t = nearbyPlaces[e], i = t.type, o = 0;
                o < t.places.length;
                o++
            ) {
                createNearbyMarker(i, t.places[o]);
            }
        }
        // setNearbyPlacesPanel();
    }
}

async function createNearbyMarker(e, t) {
    var i = t.geometry.location.lat;
    var o = t.geometry.location.lng;
    var n = new google.maps.Marker({
        position: {
            lat: i,
            lng: o
        },
        map: map,
        title: t.name,
        icon: {
            url: "/images/markers/" + e + ".png",
            size: new google.maps.Size(29, 29),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14.5, 14.5),
            scaledSize: new google.maps.Size(29, 29)
        },
        zIndex: 1,
        type: e
    });
    nearbyMarkers.push(n);
    var r = new google.maps.InfoWindow({
        maxWidth: 240,
        content:
            '<div id="nearby-infobox"><div class="type ' +
            e +
            '">' +
            nearbyTypeToString(e).toUpperCase() +
            "</div><h1>" +
            t.name +
            "</h1>" +
            (t.vicinity
                ? '<div class="address">' + t.vicinity + "</div>"
                : "") +
            '<a class="directions-button" href="https://www.google.com/maps/dir/?api=1&destination=' +
            t.name +
            "&destination_place_id=" +
            t.place_id +
            '" target="_blank">CÓMO LLEGAR</a></div>'
    });

    infowindows.push(r),
        n.addListener("click", function() {
            for (var e = 0; e < infowindows.length; e++)
                infowindows[e] && infowindows[e].close();
            r.open(map, n);
        });
}

function nearbyTypeToString(placeType) {
    var e = [
        {
            type: "hospital",
            translation: "hospitales"
        },
        {
            type: "pharmacy",
            translation: "farmacias"
        },
        {
            type: "school",
            translation: "centro de estudios"
        },
        {
            type: "supermarket",
            translation: "supermercado"
        },
        {
            type: "shopping_mall",
            translation: "centro comercial"
        },
        {
            type: "bus_station",
            translation: "parada de bus"
        },
        {
            type: "train_station",
            translation: "parada de tren"
        },
        {
            type: "subway_station",
            translation: "parada de metro"
        }
    ].find(function(e) {
        return e.type == placeType;
    });
    return null != e ? e.translation : placeType.replace(/_/g, " ");
}

function initAccordions() {
    $(".std-list.type-dropdown .std-list-element > .std-listener").on(
        "click",
        function(e) {
            e.preventDefault();
            $(".std-list-subelement").removeClass("active");
            $(".std-list-subanswer").slideUp();
            $(this)
                .closest(".std-list-element")
                .toggleClass("active");
            $(this)
                .closest(".std-list-element")
                .find(".std-list-answer")
                .slideToggle();
        }
    );

    $(".std-list.type-dropdown .std-list-subelement > .std-listener").on(
        "click",
        function(e) {
            e.preventDefault();
            $(this)
                .closest(".std-list-subelement")
                .toggleClass("active");
            $(this)
                .closest(".std-list-subelement")
                .find(".std-list-subanswer")
                .slideToggle();
        }
    );
}

function initMapLightBox(e) {
    $(e.target)
        .closest(".floorplan")
        .find(".mapLightBox-container")
        .slick({
            slidesTofadeIn: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            mobileFirst: true,
            dots: false
        });

    $(".mapLightBox img").attr("src", $(e.target).attr("src"));

    $(".mapHouse").on("click", function(e) {
        $(".mapLightBox").addClass("visible");
        $(".mapLightBox img").attr("src", $(this).attr("src"));
    });

    $(".mapLightBox .close-button").on("click", function() {
        $(".mapLightBox").removeClass("visible");
    });
}

function initLightBox() {
    // Slick carrousel detail
    $(".panorama").on("click", function(e) {
        if (
            $(e.target).is("#save-favorite") ||
            $(e.target).is(".mobile-only") ||
            $(e.target).is(".icon")
        ) {
            return;
        }

        $(".producto-slider-container").slick({
            slidesTofadeIn: 1,
            slidesToScroll: 1,
            speed: 300,
            arrows: true,
            infinite: true,
            adaptiveHeight: true,
            mobileFirst: true,
            dots: true
        });

        $(".producto-slider img").each(function() {
            $(this).attr("src", $(this).data("src"));
        });

        $(".producto-slider").addClass("visible");

        $(".product-hero-container .panorama .panorama-row").on(
            "click",
            function(e) {
                $(".producto-slider").addClass("visible");
                var imageIndex = $(
                    ".product-hero-container .panorama .panorama-row"
                ).index(this);
                $(".producto-slider-container").slick(
                    "slickGoTo",
                    imageIndex,
                    true
                );
            }
        );

        $(".producto-slider .close-button").on("click", function() {
            $(".producto-slider").removeClass("visible");
        });
    });
}

function resizeResultsSlider() {
    if ($(".result-slider-container.slick-initialized")) {
        var sliderWidth;
        if ($(window).width() < 1048) {
            sliderWidth = $("#results-content").width();
        } else {
            sliderWidth = $(".result-item-slide")
                .first()
                .width();
        }

        $(".result-slide, .result-slide>img").each(function() {
            $(this).width(sliderWidth);
        });
    }
}

function initResultsSlider() {
    if ($(window).width() < 1048) {
        if ($(".result-slider-container.slick-initialized")) {
            $(".result-slide, .result-slider, .result-slide img").css(
                "width",
                $(".result-item-slide").width()
            );
            $(
                ".promociones-destacadas .result-slide, .promociones-destacadas .result-slider, .promociones-destacadas .result-slide img"
            ).css(
                "height",
                $(".promociones-destacadas .result-item-slide").height()
            );
        }
        var currentImg = $("#results-content").width();

        var style = {
            transform: "translate3d(" + -currentImg + "px, 0px, -0px)"
        };

        $(".slick-track").each(function() {
            $(this).css(style);
        });

        let target = "";
        if (document.querySelector("#FeaturedPromotions")) {
            target = document.querySelector("#FeaturedPromotions");
            initIntersectionObserver(target);
        } else if (document.querySelector("#filtros")) {
            target = document.querySelector("#filtros");
            initIntersectionObserver(target);
        }
    } else {
        if ($(".result-slider-container.slick-initialized")) {
            $(
                ".result-slide.slick-slide, .result-slide img, .result-slider"
            ).css("width", $(".result-item-slide").width());
            var currentImg = $(".result-slide.slick-slide img").width();

            var style = {
                transform: "translate3d(" + -currentImg + "px, 0px, -0px)"
            };

            $(".slick-track").each(function() {
                $(this).css(style);
            });
        }
        $(".result-slider:not(.initialized)").on("mouseover", function() {
            initImageCarousel(this);
        });
    }

    $(".slick-list.draggable").each(function() {
        $(this).on("drag", function(e) {
            e.event.stopPropagation();
            e.stopImmediatePropagation();
        });
    });

    $(window).on("resize", resizeResultsSlider);
}
function initIntersectionObserver(target) {
    let observer = new IntersectionObserver(
        function(entries) {
            entries.forEach(entry => {
                if (target != "") {
                    if (entry.intersectionRatio == 1) {
                        $(".result-slider:not(.initialized)").each(function() {
                            initImageCarousel(this);
                        });
                    }
                }
            });
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 1.0
        }
    );
    observer.observe(target);
}
function initImageCarousel(target) {
    if ($(target).find(".result-slider-container").length > 0) {
        $(target)
            .find(".result-slider-container")
            .slick({
                slidesTofadeIn: 1,
                slidesToScroll: 1,
                speed: 300,
                arrows: true,
                infinite: true,
                adaptiveHeight: true,
                mobileFirst: true,
                variableWidth: true
            });

        $(target)
            .find(".slick-arrow")
            .on("click", function(e) {
                e.stopPropagation();
                e.stopImmediatePropagation();

                var resultSlider = $(target)
                    .closest(".results-item")
                    .find(".result-slider");

                if (!$(resultSlider).attr("loaded")) {
                    $(target)
                        .closest(".results-item")
                        .find(".result-slider")
                        .find("img")
                        .each(function() {
                            $(this).attr("src", $(this).data("src"));
                        });
                    $(resultSlider).attr("loaded", true);
                }
            });

        // Añadir enlace hacia la propiedad al slider
        $(target)
            .closest(".result-item-slide")
            .on("click", function() {
                window.location = $(this).attr("data-href");
            });
    }

    // Glide in slider
    $(target)
        .find("img")
        .each(function() {
            $(this).attr("src", $(this).data("src"));
        });

    // $(target).find("img").each(function() {
    //     let originalSrc = $(this).data("src");
    //     if (originalSrc) {
    //         let newSrc = originalSrc.replace("/dmiData/data/files/", "/glide-dmi/") + "?w=548&h=500&fit=crop";
    //         $(this).attr("src", newSrc);
    //     }
    // });

    $(target).addClass("initialized");
    $(target).off("mouseover");
}

function setDetailPanorama() {
    jQuery(
        ".product-hero-container .panorama .panorama-column .panorama-row"
    ).on("mouseover", function() {
        var elementHovered = jQuery(this)[0];

        var cells = jQuery(
            ".product-hero-container .panorama .panorama-column .panorama-row"
        );

        jQuery.each(cells, function(i, cell) {
            if (cell != elementHovered) {
                jQuery(cell).addClass("black");
            } else if (jQuery(cell).hasClass("black")) {
                jQuery(cell).removeClass("black");
            }
        });
    });

    jQuery(".product-hero-container .panorama").on("mouseout", function() {
        var cells = jQuery(
            ".product-hero-container .panorama .panorama-column .panorama-row"
        );

        cells.removeClass("black");
    });
}

function setSliderListListeners() {
    //Click carousel list item
    $(".image-container").on("click", function() {
        $(this)
            .find(".result-slider")
            .find(".result-slide")
            .find("img")
            .each(function() {
                $(this).attr("src", $(this).data("src"));
            });

        // $(this).find(".result-slider").find(".result-slide").find("img").each(function() {
        //     let originalSrc = $(this).data("src");
        //     if (originalSrc) {
        //         let newSrc = originalSrc.replace("/dmiData/data/files/", "/glide-dmi/") + "?w=548&h=500&fit=crop";
        //         $(this).attr("src", newSrc);
        //     }
        // });

        if (
            !$(this)
                .closest(".results-item")
                .find(".result_item_slide")
                .find(".producto-slider-container")
                .hasClass("slick-initialized")
        ) {
            $(this)
                .closest(".results-item")
                .find(".result_item_slide")
                .find(".producto-slider-container")
                .slick({
                    slidesTofadeIn: 1,
                    slidesToScroll: 1,
                    speed: 300,
                    arrows: true,
                    infinite: true,
                    adaptiveHeight: true,
                    mobileFirst: true,
                    dots: true
                });
        }

        $(this)
            .closest(".results-item")
            .find(".result_item_slide .producto-slider")
            .addClass("visible");
    });

    // $(".show-video").on("click", function () {
    //     $(this)
    //         .closest(".results-item")
    //         .find(".result_video_slide")
    //         .find("iframe")
    //         .each(function() {
    //             $(this).attr("src", $(this).data("src"));
    //         });

    //     if (
    //         !$(this)
    //             .closest(".results-item")
    //             .find(".result_video_slide")
    //             .find(".producto-slider-container")
    //             .hasClass("slick-initialized")
    //     ) {
    //         $(this)
    //             .closest(".results-item")
    //             .find(".result_video_slide")
    //             .find(".producto-slider-container")
    //             .slick({
    //                 slidesTofadeIn: 1,
    //                 slidesToScroll: 1,
    //                 speed: 300,
    //                 arrows: false,
    //                 infinite: true,
    //                 adaptiveHeight: true,
    //                 mobileFirst: true,
    //             });
    //     }

    //     $(this)
    //         .closest(".results-item")
    //         .find(".result_video_slide .producto-slider")
    //         .addClass("visible");
    // });

    $(".producto-slider .close-button").on("click", function() {
        $(this)
            .closest(".producto-slider")
            .removeClass("visible");
    });

    $(".image-container").trigger("click");
}

function initIframes() {
    $('[data-toggle="iframe"]').each(function() {
        let $iframe = $(this);

        let src = $iframe.data("src");
        let width = $iframe.data("width");
        let height = $iframe.data("height");

        $iframe.html(
            $("<iframe />", {
                src: src,
                width: width,
                height: height
            })
        );
    });
}

function initPromotionsFilters() {
    $("#filtros .cbreselectmultiple").on("change", function() {
        $(".promo-busqueda").show();
        commonFilters = [];
        locationFilters = [];

        $(".cbreselectmultiple").each(function() {
            const name = $(this).attr("name");
            const values = $(this).val();

            if (values && values.length > 0) {
                values.forEach(value => {
                    const filterData = {
                        field: name,
                        value: sanitizeText(value),
                        label: $(this).find(`option[value="${value}"]`).text()
                    };

                    if (name === "localizacion") {
                        locationFilters.push(filterData); // Localización va aquí
                    } else {
                        commonFilters.push(filterData); // Tipo_inmueble y otros van aquí
                    }
                });
            }
        });

        applyFilters();
    });

    // Buscador de promociones con filtro preaplicado de provincia
    $(".cbreselectmultiple").each(function() {
        if ($(this).val().length > 0) {
            $(this).trigger("change");
        }
    });

    // $("#busqueda-promocion-buscador").on("input blur change", function () {
    //     clearTimeout(searchDebounce);

    //     searchDebounce = setTimeout(function () {
    //         searchPromotionsByText();
    //     }, 300);
    // });

    $("#clear-filters").on("click", function() {
        clearAllFilters();
    });
}

function parseFilterData(data) {
    return sanitizeText(data)
        .replace(/ /g, "")
        .replace(/-/g, "")
        .split(",");
}

function applyFilters() {
    const $promos = $(".promo-busqueda").hide().addClass("notselected");
    const selectedPropTypes = commonFilters
        .filter(f => f.field === "tipo_inmueble")
        .map(f => sanitizeText(f.value));

    const selectedLocations = locationFilters.map(f => sanitizeText(f.value));

    const otherFilters = commonFilters.filter(f =>
        f.field !== "tipo_inmueble" && f.field !== "localizacion"
    );

    $promos.each(function () {
        const $promo = $(this);
        const promoPropType = sanitizeText($promo.data("prop_type"));
        const promoProvince = sanitizeText($promo.data("province"));

        const matchesPropType = !selectedPropTypes.length || selectedPropTypes.includes(promoPropType);
        const matchesLocation = !selectedLocations.length || selectedLocations.includes(promoProvince);

        let matchesOtherFilters = true;

        if (otherFilters.length) {
            const allPromoValues = [
                ...parseFilterData($promo.data("property")),
                ...parseFilterData($promo.data("services")),
                ...parseFilterData($promo.data("rooms"))
            ].map(sanitizeText);

            matchesOtherFilters = otherFilters.every(filter => 
                allPromoValues.includes(sanitizeText(filter.value))
            );
        }

        if (matchesPropType && matchesLocation && matchesOtherFilters) {
            $promo.show().removeClass("notselected");
        }
    });

    $(".no-results").toggle($(".promo-busqueda:visible").length === 0);
    updateFilterTags();
}

// Función para actualizar las etiquetas de filtros seleccionados
function updateFilterTags() {
    const allFilters = locationFilters.concat(commonFilters);

    $(".filter-tags-container").empty();

    allFilters.forEach(filter => {
        $(".filter-tags-container").append(
            '<div class="filter-tag inline items-center gap-xs p-xs text-uppercase text-14 main-font-medium leading-16">' +
                filter.label +
                '<img class="close cursor-pointer" src="/images/icons/close.svg" data-filter-value="' +
                filter.value +
                '" alt="Close filter" width="12" height="12">' +
                "</div>"
        );
    });

    // Evento para eliminar etiquetas de filtros
    $(".filter-tag .close").on("click", function() {
        const filterValue = $(this).data("filter-value");

        $(".cbreSelect-options").each(function() {
            $(this)
                .find("li.selected")
                .each(function() {
                    if (
                        sanitizeText($(this).attr("rel")) ==
                        sanitizeText(filterValue)
                    ) {
                        $(this).trigger("click");
                    }
                });
        });
    });

    if (allFilters.length > 0) {
        $(".filter-tags").addClass("inline");
        $(".filter-tags").removeClass("d-none");
    }

    if (allFilters.length === 0) {
        $(".filter-tags").addClass("d-none");
        $(".filter-tags").removeClass("inline");
    }
}

function clearAllFilters() {
    $(".cbreSelect-options").each(function() {
        $(this)
            .find("li.selected")
            .each(function() {
                $(this).trigger("click");
            });
    });
}

// function searchPromotionsByText() {
//     $(".promo-busqueda").show();

//     let value = $("#busqueda-promocion-buscador").val();
//     value = value.toUpperCase();

//     if (value !== "") {
//         $(".promo-busqueda:visible").each(function () {
//             let city = $(this).data("city");
//             if (city !== undefined) {
//                 city = city.toUpperCase();
//             } else {
//                 city = "";
//             }

//             let province = $(this).data("province");
//             if (province !== undefined) {
//                 province = province.toUpperCase();
//             } else {
//                 province = "";
//             }

//             let name = $(this).data("name");
//             if (name !== undefined) {
//                 name = name.toUpperCase();
//             } else {
//                 name = "";
//             }

//             if (
//                 !city.startsWith(value) &&
//                 !province.startsWith(value) &&
//                 !name.startsWith(value)
//             ) {
//                 jQuery(this).hide();
//             }
//         });

//         $(".titulo-promociones-buscador").each(function () {
//             let province = $(this).data("provincetitle");
//             if (province !== undefined) {
//                 province = province.toUpperCase();

//                 if (
//                     $(
//                         '.promo-busqueda[data-province="' +
//                             province +
//                             '"]:visible'
//                     ).length === 0
//                 ) {
//                     $(this).hide();
//                 } else {
//                     $(this).show();
//                 }
//             }
//         });
//     } else {
//         $(".promo-busqueda").show();
//         $(".titulo-promociones-buscador").show();
//     }

//     var num = $(".promo-busqueda:visible").length;

//     if (num == 0) {
//         $(".no-results").show();
//     } else {
//         $(".no-results").hide();
//     }
// }

function initMapGallery() {
    let thumbnails = $(".thumbnails img").toArray();

    $(thumbnails)
        .eq(0)
        .addClass("active");
    thumbnails.forEach(thumbnail => {
        $(thumbnail).on("click", function(e) {
            $(".thumbnails img").removeClass("active");
            $(this).addClass("active");
            $(".main-image img").attr("src", $(e.target).attr("src"));
        });
    });
}

function sanitizeText(str) {
    return str
        .toString()
        .trim()
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/á/g, "a")
        .replace(/é/g, "e")
        .replace(/í/g, "i")
        .replace(/ó/g, "o")
        .replace(/ú/g, "u")
        .replace(/ñ/g, "n");
}
